
import { Row, Col, Typography, Collapse } from 'antd';
const { Title, Paragraph } = Typography;
export const faqItems = [
  {
    "key": "1",
    "label": "What is ShuttleOps?",
    "children": (
      <Paragraph>
        ShuttleOps is a club management platform designed specifically for badminton. It helps clubs track attendance, take payments, communicate with players, and allocate players fairly to courts using a digital peg board.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "2",
    "label": "Do players need to install any software?",
    "children": (
      <Paragraph>
        No, ShuttleOps is a web-based platform accessible on any device with an internet connection.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "4",
    "label": "What is the digital peg board?",
    "children": (
      <Paragraph>
        It’s a fair and automated way of assigning players to courts during club sessions. It ensures even playing time and better variety in opponents.
      </Paragraph>
    ),
    "primary": true,
    "finance" : false
  },
  {
    "key": "5",
    "label": "How are games created during a session?",
    "children": (
      <Paragraph>
        Games are created automatically using player skill levels, previous game data, and availability, ensuring balanced and varied matchups.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "6",
    "label": "Is there a free version?",
    "children": (
      <Paragraph>
        Yes. ShuttleOps offers a free tier with basic features. Clubs can upgrade to unlock payments, subscriptions, and advanced tools.
        The ongoing Free plan includes 10 members. Standard costs £4 a month and includes 25 members.
        Existing bolt-ons can add features or raise capacity, including 150 members. These are plan allowances, not a product limit.
      </Paragraph>
    ),
    "primary": true,
    "finance" : false
  },
  {
    "key": "7",
    "label": "How does player tracking work?",
    "children": (
      <Paragraph>
        ShuttleOps tracks who attends sessions, what games they play, and how often. This data is used for stats, payments, and fair game creation.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "8",
    "label": "How are payments handled?",
    "children": (
      <Paragraph>
        Clubs can charge per session or via subscriptions. Payments are taken via Direct Debit through Stripe, and players can view their payment history anytime.
      </Paragraph>
    ),
    "primary": true,
    "finance" : true
  },
  {
    "key": "21",
    "label": "What fees apply to Direct Debit payments?",
    "children": (
      <Paragraph>
        Stripe charges 1% per transaction, with a 20p minimum. ShuttleOps charges a separate 1%, with the same 20p minimum. Pro and Extra group weekly session charges into one monthly transaction.
      </Paragraph>
    ),
    "primary": false,
    "finance" : true
  },
  {
    "key": "9",
    "label": "Is Stripe secure for payments?",
    "children": (
      <Paragraph>
        Yes. Stripe is a leading global payment provider, fully regulated and secure. Your bank details are never stored on ShuttleOps.
      </Paragraph>
    ),
    "primary": false,
    "finance" : true
  },
  {
    "key": "10",
    "label": "Do players have to register to be added to a club?",
    "children": (
      <Paragraph>
        No. Club admins can add players with an email. Players only need to register if they want to access their own stats and payment details.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "11",
    "label": "Can a club be private?",
    "children": (
      <Paragraph>
        Yes. A club can be hidden from public search. Players can only join via direct invite or by entering a unique Club ID.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "12",
    "label": "How are stats calculated?",
    "children": (
      <Paragraph>
        Stats are based on session attendance, games played, and partner/opponent history. Clubs don’t need to enter scores for the system to work.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "13",
    "label": "Can clubs send messages to players?",
    "children": (
      <Paragraph>
        Yes. Clubs can send announcements, session invites, and updates directly through the platform.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "14",
    "label": "Can I try it before my club commits?",
    "children": (
      <Paragraph>
        Yes. You can create a test club, add fake players, and explore features like the peg board and payment flow without committing.
        The private test club includes 10 fake players and is automatically removed after seven days.
        Your real club can use the separate ongoing Free plan with 10 members.
      </Paragraph>
    ),
    "primary": true,
    "finance" : false
  },
  {
    "key": "15",
    "label": "Do players get notified of new sessions?",
    "children": (
      <Paragraph>
        Registered players will get an email when they’re added to a new session. You can also choose to notify or not when creating sessions.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  },
  {
    "key": "17",
    "label": "What’s needed to receive payments as a club?",
    "children": (
      <Paragraph>
        Club admins must add a bank account in the Club Settings under the Banking tab to receive payouts.
      </Paragraph>
    ),
    "primary": false,
    "finance" : true
  },
  {
    "key": "18",
    "label": "How long do payouts take?",
    "children": (
      <Paragraph>
        Payouts are processed monthly and can take up to 7 days to clear, depending on the payment method used.
      </Paragraph>
    ),
    "primary": false,
    "finance" : true
  },
  {
    "key": "19",
    "label": "Can I see my own payment history?",
    "children": (
      <Paragraph>
        Yes. Players can go to their Profile, click the “My Payments” tab, and view everything they’ve paid or owe by club.
      </Paragraph>
    ),
    "primary": false,
    "finance" : true
  },
  {
    "key": "20",
    "label": "Where can I get help?",
    "children": (
      <Paragraph>
        Visit the ShuttleOps Support Portal for documentation, guides, and to raise support tickets if needed. You can log in using the same account as the app.
      </Paragraph>
    ),
    "primary": false,
    "finance" : false
  }
]
